export default {
    apiKey: "AIzaSyBfCM0Nnb6OwE-fRV7B3ucl4eEZpsXcagM",
    authDomain: "sociallogin-169db.firebaseapp.com",
    projectId: "sociallogin-169db",
    storageBucket: "sociallogin-169db.appspot.com",
    messagingSenderId: "441691645749",
    appId: "1:441691645749:web:ae058e168715466cd98e7c",
    measurementId: "G-G6K4F2M6MK"
  };